export default __webpack_public_path__ + "39a076c69caf6eea78aa8f3c410ac7e1.png";